import React from "react";
import { Link, useNavigate } from "react-router-dom";

interface FormBreadcrumbProps {
  formName: string; // e.g., "Category", "Company", "Department"
  isEdit: boolean; // Whether the form is in edit mode
  navigatePath: string; // Path to navigate back to (e.g., "/master/category")
  isPrefixRequired?: boolean;
}

const FormBreadcrumb: React.FC<FormBreadcrumbProps> = ({
  formName,
  isEdit,
  navigatePath,
  isPrefixRequired=true
}) => {
  const actionText = isEdit ? "Edit" : "Add";
  const fullTitle = isPrefixRequired ? `${actionText} ${formName}` : formName;
  const navigate = useNavigate();

  return (
    <div className="d-flex flex-column flex-md-row justify-content-between align-items-start align-items-md-center gap-2 mb-3">
      {/* Left: Back icon and heading */}
      <div className="d-flex align-items-center gap-2">
        <span
          style={{ fontSize: "24px", cursor: "pointer" }}
          onClick={() => navigate(navigatePath)}
        >
          ←
        </span>
        <h5 className="mb-0 fw-bold">{fullTitle}</h5>
      </div>

      {/* Right: Breadcrumb */}
      <div className="text-muted">
        <Link
          to={navigatePath}
          style={{ color: "inherit", textDecoration: "none" }}
        >
          {formName} &gt;{" "}
        </Link>
        {fullTitle}
      </div>
    </div>
  );
};

export default FormBreadcrumb;

